import { IPrepaidProgramFormMeta } from '@Modules/cardManagementSystem/prepaid/containers/formHandlers/cardHolder/prepaidProgram/PrepaidProgramMeta';
import {
  CustomInputSelect
} from '@Modules/core/components';
import CustomFormControl from '@Modules/core/components/form/CustomFormControl';
import { ChakraComponents as CC } from '@Modules/core/lib/chakra';
import displayCustomInputs from '@Shared/utils/displayCustomInputs';
import React from 'react';
type Props = {
    meta: IPrepaidProgramFormMeta,
    register: any,
    errors: any,
    isLoading: any,
};

export default React.forwardRef(function RechargeParametersTabPanelFormUI ({  meta, register, errors, isLoading }: Props, ref: any) {

  const submitBtnRef = React.useRef<HTMLButtonElement>(null);

  return (
    <CC.Box>
      <CC.SimpleGrid columns={{base: 1, md: 2, lg:2}} spacing={10} my={10}>
        {displayCustomInputs<IPrepaidProgramFormMeta>(meta, register, errors, isLoading, [ meta.accountMaxLimit.name])}

        <CustomFormControl
          label={meta.rechargeFees.label}
          isLoading={isLoading}
          isInvalid={!!errors[meta.rechargeFees.name]}
        >
          <CustomInputSelect
            meta={meta.rechargeFees}
            register={register(meta.rechargeFees.name)}
            hasError={errors[meta.rechargeFees.name]}
          />
        </CustomFormControl>
      </CC.SimpleGrid>

      <CC.SimpleGrid columns={{base: 1, md: 2, lg:2}} spacing={10} mb={10}>
        {displayCustomInputs<IPrepaidProgramFormMeta>(meta, register, errors, isLoading, [ meta.rechargeMinValue.name])}

        {displayCustomInputs<IPrepaidProgramFormMeta>(meta, register, errors, isLoading, [ meta.rechargeMaxValue.name])}
      </CC.SimpleGrid>       

        

    </CC.Box>
  );
});

